module.exports = __webpack_public_path__ + "static/media/guardian-team-left.9031cdf3.webp";